import { InfoBox, settings } from "@desp-aas/desp-ui-fwk"
import { NavLink } from "react-router-dom"

export const PrivacyPolicyContent = () => {
    return (
        <div id="privacy-policy-content" className="app-document">
            <h1>Privacy policies</h1>
            <InfoBox type="info" title="Privacy settings">
                <p>If you want to change your privacy settings, please go to <NavLink to={settings.privacySettingsPath}>Privacy settings</NavLink>.</p>
            </InfoBox>
            <h2>Personal information</h2>
            <p>
                Some information about how to access the site may be received by our computer
                systems, such as the visitor's IP address. This information is not collected for explicit
                use (for example, to contact a user or for advertising). They are nevertheless recorded in
                system logs from systems and equipment that allow access and execution of the site
                (e.g. FireWall, Operating System). This information is not explicitly correlated with any
                personal information (e.g. user name), unless duly indicated in this notice.
            </p>

            <p>
                Similarly, login data (email address, password) is saved and used only to allow access to
                the site.
            </p>

            <p>
                By registering, you agree to be contacted via the email address provided when creating
                this account. This email address will be used to inform you of updates, whether they
                concern notifications related to your participation in the services, changes to the
                platform's usage policy or new features. This data is retained until the User account
                is deleted.
            </p>

            <p>
                Any information that may be voluntarily provided by a user (e.g. name and email address
                or telephone number in a contact form) is only used for the function required by the user
                (e.g. to respond to a contact request).
            </p>

            <p>
                In the event that accounts are used in a manner that adversely affects service quality,
                ACRI-ST reserves the right to delete these identifiers and all related operations without
                justification. This rule applies, among other things, to temporary emails created to
                generate transactions and which no longer respond after these requests.
            </p>

            <p>
                Consent is required to enable you to add projects and receive notifications about
                actions taken on them.
            </p>

            <ul>
                <li>
                    Transmission of your email address to GitLab
                </li>
            </ul>

            <p>
                This consent is optional and unchecked by default, but without your authorization, you
                will have limited access to the features offered by DESP-AAS.
            </p>

            <p>
                In the event that accounts are used in a manner that adversely affects service quality,
                ACRI-ST reserves the right to delete these identifiers and all related operations in
                accordance with its legitimate interest under Article 6(1)(f) GDPR without
                justification. This rule applies, among other things, to temporary emails created to
                generate transactions and which no longer respond after these requests.
            </p>
            
            <h2>Cookies</h2>

            <p>
                We use Core cookies that are essential to provide our website's services. For example,
                these include cookies to note you’ve accepted our personal data policy or cookies to
                make it possible for you to stay logged into our Web site (the latter being applicable only
                to sites where a user login function exists).
            </p>

            <p>
                In addition, we may use cookies to track our Web site usage, through third-party
                technologies such as Google Analytics. This is used to make anonymous statistics
                about new visits, return visits and page views. These usage cookies measure how often
                visitors navigate to our sites and which pages are visited. We use this anonymous
                information to get a better sense of how our content is relevant to visitors and to improve
                our sites (for example, we collect information about which of our pages are
                most frequently visited). In that respect we may use third-party cookies (for example, the
                Google Analytics cookies provide information such as navigation between pages). This
                anonymous information may be shared with third parties to provide anonymous statistics
                on the site usage (for example we may share project site usage information with project
                stakeholders).
            </p>

            <p>
                We don’t use Advertising cookies
            </p>

            <h3>Functional cookies</h3>

            <p>
                These cookies are essential in order to use the website and its features.
            </p>


            <table>
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Duration
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            access_token
                        </td>
                        <td>
                            Session
                        </td>
                    </tr>
                    <tr>
                        <td>
                            refresh_token
                        </td>
                        <td>
                            Session
                        </td>
                    </tr>
                </tbody>
            </table>

            <h3>Analytics cookies</h3>

            <p>
                Tracking cookies that are used to collect anonymous usage analytics of the website
                activity in order to improve the platform.
            </p>

            <table>
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Duration
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            _pk_id
                        </td>
                        <td>
                            13 months
                        </td>
                    </tr>
                    <tr>
                        <td>
                            _pk_ses
                        </td>
                        <td>
                            30 minutes
                        </td>
                    </tr>
                    <tr>
                        <td>
                            _pk_ref
                        </td>
                        <td>
                            6 months
                        </td>
                    </tr>
                    <tr>
                        <td>
                            _pk_testcookie
                        </td>
                        <td>
                            30 minutes
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* <h3>Telemetry</h3>

            <p>
                These are used in order to reproduce errors on the platform in order to fix them rapidly.
                This greatly helps us improve the platform and the user experience.
            </p>
            <InfoBox type="info" small>
                This does not use cookies
            </InfoBox> */}

            <InfoBox type="info" title="Note">
                You can always set your browser to block these cookies. In such a
                case, functions and services above will not work. For example, we won’t be able to save
                your personal data policy consent.
            </InfoBox>


            <h2>Data retention</h2>

            <p>
                Personal data are registered and kept during a limited duration of 6 years, according to
                RGPD art.5 . When a user does not connect for 6 years then his personal
                data are automatically deleted. However, if a user wants to delete his personal
                information before this delay, he can contact our service without any explanation.
            </p>

            <h2>Disclosure of data – Legal requirements</h2>

            <p>
                We may disclose your Personal Data in the good faith belief that such action is
                necessary to:
            </p>

            <ul>
                <li>
                    To comply with a legal obligation
                </li>
                <li>
                    To protect and defend our rights or property
                </li>
                <li>
                    To prevent or investigate possible wrongdoing in connection with the Service
                </li>
                <li>
                    To protect the personal safety of users of the Service or the public
                </li>
                <li>
                    To protect against legal liability
                </li>
            </ul>

            <h2>Security of data</h2>

            <p>
                The security of your data is important to us but remember that no method of
                transmission over the Internet, or method of electronic storage is 100% secure. While
                we strive to use commercially acceptable means to protect your Personal Data, we
                cannot guarantee its absolute security.
            </p>

            <h2>Service providers</h2>

            <p>
                We may employ third party companies and individuals to facilitate our Service (“Service
                Providers”), to provide the Service on our behalf, to perform Service-related services or
                to assist us in analyzing how our Service is used. These third parties have access to your
                Personal Data only to perform these tasks on our behalf and are obligated not
                to disclose or use it for any other purpose.
            </p>

            <h2>Links to other sites</h2>

            <p>
                Our Service may contain links to other sites that are not operated by us. If you click on
                a third party link, you will be directed to that third party’s site. We strongly advise you
                to review the Privacy Policy of every site you visit. We have no control over and assume
                no responsibility for the content, privacy policies or practices of any third party sites or
                services.
            </p>

            <p>
                This website may include links to other websites which may be of interest to you. We do
                not endorse or approve and have no responsibility for the content of any website to
                which this website links.
            </p>

            <p>
                No authority is given (implied or expressly) by us or the contributors to the website to
                deep link to or to frame any of the content that appears on the website or to use a
                representation of any of our names or logos, trademarks, brand names contained on this
                website. We reserve the right to prohibit links to our homepage.
            </p>



            <h2>Children’s privacy</h2>

            <p>
                Our Service does not address anyone under the age of 15 (“Children”). We do not
                knowingly collect personally identifiable information from anyone under the age of 15. If
                you are a parent or guardian and you are aware that your child has provided us with
                Personal Data, please contact us. If we become aware that we have collected Personal
                Data from children without verification of parental consent, we take steps to remove that
                information from our servers.
            </p>

            <h2>Users rights</h2>

            <p>
                As our website user, you have the following rights to request:
            </p>

            <ul>
                <li>
                    The <u>Access to your personal data</u>
                </li>
                <li>
                    The <u>Rectification / editing of your personal data</u>
                </li>
                <li>
                    The <u>Deletion of it</u> when it is no longer necessary
                </li>
                <li>
                    The <u>Right to withdrawal of consent</u>
                </li>
                <li>
                    The <u>Restriction of access processing of your personal data</u>, in particular to oppose the
                    use of automated decision-making (profiling)
                </li>
                <li>
                    Request <u>A copy of your personal data</u>
                </li>
                <li>
                    Right to <u>Seek compensation for damages</u> caused by a violation of the right
                </li>
                <li>
                    Make a <u>complaint to a control authority</u>
                </li>
            </ul>

            <p>
                If you want to use your rights or if you have any questions about this Privacy Policy,
                please contact us.
            </p>

            <ul>
                <li>Email : privacy@acri-st.fr</li>
                <li>Phone : +33 (0)4 92 92 75 00</li>
                <li>Address : 260 route du Pin Montard, B.P. 234, 06904 Sophia-Antipolis, France</li>
            </ul>

            <h2>Disclaimer</h2>

            <p>
                Whilst we have taken every reasonable precaution and care in compiling this website,
                we do not make any representation or warranties of any kind (express or implied) with
                respect to the contents or operation of this website, and any such representations and
                warranties are excluded by this notice. We do not warrant that use of this website will be
                uninterrupted or error free. Your use of this website and the materials contained in it are
                done so entirely at your own risk. We do not accept any liability for losses or damages,
                whether direct or indirect, that you may suffer as a result of your use of this website or
                your reliance upon the contents of this website including but not limited to computer
                service or system failure, access delays or interruption, data non-delivery or misdelivery, computer viruses or other harmful components, breaches of security or
                unauthorized use of the system arising from “hacking” or otherwise.
            </p>

            <p>
                This website is made available on the basis that (except in respect of fraud or of death or
                personal injury caused by our negligence), all liability whatsoever for any loss or damage
                arising out of or in connection with your use of this website, or reliance upon the
                contents of this website, is excluded to the fullest extent permitted by law.
            </p>

            <p>
                Any typographical, clerical or other error or omission in any page posted on this website
                shall be subject to correction or deletion (as appropriate) without any liability on our
                part.
            </p>


            <p>
                We reserve the right to make changes to this website at any time without notice and it is
                your responsibility to revisit this page from time to time to re-read this notice. Any
                revised terms shall take effect as at the date of its posting.
            </p>

            <p>
                The content of this website, any dispute arising out of the website, and your relationship
                with us are governed by French law and shall be subject to the exclusive jurisdiction of
                the French Courts.
            </p>

        </div>
    )
}